module.exports = JSON.parse('{}', function (name, value) {
              return name !== 'toString' ? value : function () { return value };
            })